import { UnnamedWidget } from 'lib-node-amb-renderer';

import type { ExtractionDataIconProps } from './ExtractionDataIconComponent';

export class ExtractionDataIconClass extends UnnamedWidget {
  iconType?: string | number;
  color?: string;
  isConfidence?: boolean;

  constructor(props: ExtractionDataIconProps) {
    super(props);
    this.iconType = props.iconType;
    this.color = props.color;
    this.isConfidence = props.isConfidence;
  }
}

export { default } from './ExtractionDataIconComponent';
